import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

export const useModalState = () => {
	const [isOpen, setIsOpen] = useState(false)
	const path = usePathname()
	const handleOpen = () => setIsOpen(true)

	const handleClose = () => setIsOpen(false)
	useEffect(() => {
		setIsOpen(false)
	}, [path])
	return {
		isOpen: isOpen,
		open: handleOpen,
		close: handleClose
	}
}
